import React from 'react';
import { DialogTitle, IconButton, Typography } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/styles';
import { noop } from 'lodash';
import { colorPalette } from 'utils/colorsPalette';
import { usePhoneView } from '@michelin/acid-components';

interface Props {
  onClose?: () => void;
  title: string;
  subtitle?: string;
  showClose?: boolean;
  backGroundColor?: string;
  closeIconColor?: 'white' | 'black';
  icon?: React.ReactElement;
  rightElement?: React.ReactElement;
  subtitleColor?: "inherit" | "initial" | "primary" | "secondary" | "textPrimary" | "textSecondary" | "error"
}

export const ModalTitle = ({
  onClose = noop,
  title,
  subtitle,
  showClose = true,
  backGroundColor = colorPalette.lightGray,
  closeIconColor,
  icon,
  rightElement,
  subtitleColor,
}: Props) => {
  const useStyles = makeStyles((theme: Theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      background: backGroundColor,
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  }));

  const classes = useStyles();
  const mobileView = usePhoneView();

  return (
    <>
      <DialogTitle disableTypography className={classes.root}>
        <div style={{ width: 'fit-content', paddingRight: mobileView && showClose ? 25 : 0 }}>
          <Typography variant="h6">
            {icon && <div style={{ margin: 16, display: 'inline' }}>{icon}</div>}
            {title}
            {rightElement && <div style={{ margin: 16, display: 'inline' }}>{rightElement}</div>}
          </Typography>
          {subtitle && <Typography variant="subtitle2" color={subtitleColor}>{subtitle}</Typography>}
        </div>
        {showClose && (
          <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon style={{ color: closeIconColor }} />
          </IconButton>
        )}
      </DialogTitle>
    </>
  );
};
